import React, { Component } from 'react';
import { Card, Button, Input, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input;

class MemoModule extends Component {
    state = {
        loading: false,
        saving: false,
        editing: false,
        content: '',
        originalContent: '',
    };

    componentDidMount() {
        if (this.props.selectedDate) {
            this.loadMemo();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.loadMemo();
        }
    }

    loadMemo = () => {
        const { selectedDate } = this.props;
        if (!selectedDate) return;

        this.setState({ loading: true, editing: false });
        const { userId } = sessionStorage;

        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.queryMemo,
            data: { curUserId: userId, date: selectedDate },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success && res.data) {
                    const content = res.data.content || '';
                    this.setState({ content, originalContent: content });
                } else {
                    this.setState({ content: '', originalContent: '' });
                }
                this.setState({ loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    };

    handleEdit = () => {
        this.setState({ editing: true });
    };

    handleSave = () => {
        const { selectedDate } = this.props;
        const { content } = this.state;
        const { userId } = sessionStorage;

        this.setState({ saving: true });

        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.saveMemo,
            data: { curUserId: userId, date: selectedDate, content },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success) {
                    message.success('保存成功');
                    this.setState({
                        originalContent: content,
                        editing: false,
                    });
                    this.props.onMemoSaved && this.props.onMemoSaved();
                }
                this.setState({ saving: false });
            },
            errorResult: () => {
                this.setState({ saving: false });
            },
        };
        $.sendRequest(options);
    };

    handleCancel = () => {
        const { originalContent } = this.state;
        this.setState({ content: originalContent, editing: false });
    };

    handleContentChange = (e) => {
        this.setState({ content: e.target.value });
    };

    render() {
        const { loading, saving, editing, content } = this.state;

        return (
            <Card className="memo-module" title="备忘录">
                <Spin spinning={loading}>
                    {editing ? (
                        <div className="memo-edit">
                            <TextArea
                                value={content}
                                onChange={this.handleContentChange}
                                rows={4}
                                placeholder="请输入备忘录内容..."
                            />
                            <div className="memo-actions">
                                <Button type="primary" onClick={this.handleSave} loading={saving}>
                                    保存
                                </Button>
                                <Button onClick={this.handleCancel} style={{ marginLeft: 8 }}>
                                    取消
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="memo-view">
                            <div className="memo-content">
                                {content || <span className="empty-text">暂无备忘录</span>}
                            </div>
                            <Button type="link" onClick={this.handleEdit}>
                                编辑
                            </Button>
                        </div>
                    )}
                </Spin>
            </Card>
        );
    }
}

export default MemoModule;



// WEBPACK FOOTER //
// ./src/components/homePage/monthlyPlan/MemoModule.js